var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M6.226 0c-.287 0-2.58.863-4.396 3.356C.014 5.849-.273 7.479.205 7.766c.478.288 2.676-.767 3.44-.192.765.576.57 1.425-.003 2.671-.574 1.247-1.087 1.635-.978 1.744.108.11 2.638-.572 4.454-3.16 1.816-2.59 2.166-4.419 1.688-4.706-.477-.288-3.138 1.32-3.823.192C4.3 3.185 6.513 0 6.226 0z"
  })));
};
export default SvgBolt;